import http from "../http";

class CommonDataService {
	getNewsCategories() {
		return http.get("/newscategories");
	}

	getOffices() {
		return http.get(`/alloffices`);
	}

	getNews(params) {
		return http.get("/news/list", {
			params: params,
		});
	}
	getNewsById(id) {
		return http.get(`/news/data/${id}`);
	}
	deleteNews(id) {
		return http.delete(`/news/${id}`);
	}
	getShortCutId(source) {
		return http.get(`/aboutusid?source=${source}`);
	}
	GetHeaderImage(id) {
		return http.get(`/getheaderimage/${id}`);
	}
	GetSocialMediaLink(id) {
		return http.get(`/getsocialmedialink/${id}`);
	}

	getGalleries(params) {
		return http.get("/galleries/list", {
			params: params,
		});
	}
	getGalleryById(id) {
		return http.get(`/galleries/data/${id}`);
	}
	deleteGallery(id) {
		return http.delete(`/galleries/${id}`);
	}
	getGalleryItem(id, deleteIds) {
		return http.get(`/galleries/items/${id}?delete=${deleteIds}`);
	}
	uploadGalleryItem(file, onUploadProgress, token, id) {
		let formData = new FormData();

		formData.append("image", file);
		formData.append("Id", id);

		return http.post("/galleries/upload", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: "Bearer " + token,
			},
			onUploadProgress,
		});
	}

	getVideos(params) {
		return http.get("/videos/list", {
			params: params,
		});
	}
	getVideoById(id) {
		return http.get(`/videos/data/${id}`);
	}
	deleteVideo(id) {
		return http.delete(`/videos/${id}`);
	}

	getReviews(params) {
		return http.get("/reviews/list", {
			params: params,
		});
	}

	getRecentSales(params) {
		return http.get("/recent_sales/list", {
			params: params,
		});
	}
	getRecentSalesById(id) {
		return http.get(`/recent_sales/data/${id}`);
	}
	deleteRecentSales(id) {
		return http.delete(`/recent_sales/${id}`);
	}

	getFeaturedListing(params) {
		return http.get("/featured_listing/list", {
			params: params,
		});
	}
	getFeaturedListingById(id) {
		return http.get(`/featured_listing/data/${id}`);
	}
	deleteFeaturedListing(id) {
		return http.delete(`/featured_listing/${id}`);
	}

	getSoldListing(params) {
		return http.get("/sold_listing/list", {
			params: params,
		});
	}
	getSoldListingById(id) {
		return http.get(`/sold_listing/data/${id}`);
	}
	deleteSoldListing(id) {
		return http.delete(`/sold_listing/${id}`);
	}

	getFeaturedAgent(params) {
		return http.get("/featured_agent/list", {
			params: params,
		});
	}
	getFeaturedAgentById(id) {
		return http.get(`/featured_agent/data/${id}`);
	}
	deleteFeaturedAgent(id) {
		return http.delete(`/featured_agent/${id}`);
	}

	getCareer(params) {
		return http.get("/career/list", {
			params: params,
		});
	}
	getCareerById(id) {
		return http.get(`/career/data/${id}`);
	}
	deleteCareer(id) {
		return http.delete(`/career/${id}`);
	}
	getCareerCategory() {
		return http.get("career/category");
	}
	getCareerLevel() {
		return http.get("career/level");
	}
	getCareerLocation() {
		return http.get("career/location");
	}

	getDeveloper(params) {
		return http.get("/developer/list", {
			params: params,
		});
	}
	getDeveloperById(id) {
		return http.get(`/developer/data/${id}`);
	}
	deleteDeveloper(id) {
		return http.delete(`/developer/${id}`);
	}
}

export default new CommonDataService();
